import { createSelector } from '@ngrx/store';
import * as fromPageCriteriaState from './page-criteria.reducer';
import { ProjectState, selectProjectState } from 'app/store/project/project.state';

export const pageCriteria = createSelector(
  selectProjectState,
  (state: ProjectState, key: string) => fromPageCriteriaState.selectEntities(state.pageCriteria)[key]
);
